module.exports = __webpack_public_path__ + "img/godle_bg.e0099cc3.png";